var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui simple dropdown item borderless ciindicator"},[_c('a',{staticClass:"ui yellow label",on:{"click":_vm.show_detail}},[_vm._v(" 兼容性问题 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }